(function () {
  'use strict';
  if (window.__egHatOfferComparisonInitialized) return;
  window.__egHatOfferComparisonInitialized = true;

  var widgets = Array.prototype.slice.call(document.querySelectorAll('[data-eg-hat-offer]'));
  if (!widgets.length) return;

  var SHIPPING_CENTS = 672;
  var FREE_SHIPPING_CENTS = 6000;
  var OFFER_SEEN_DWELL_MS = 1000;
  var offerSeenEmitted = false;
  var offerVisibilityStates = [];

  var eligibleIdsPromise = fetch('/collections/hats-and-beanies/products.json?limit=250', {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' }
  }).then(function (response) {
    if (!response.ok) throw new Error('eligible-products-' + response.status);
    return response.json();
  }).then(function (data) {
    return new Set((data.products || []).map(function (product) { return String(product.id); }));
  });

  function isQaSession() {
    if (document.documentElement.dataset.egClarityQaSession === 'true') return true;
    try {
      var params = new URLSearchParams(window.location.search);
      return params.has('_qa') || params.has('preview_theme_id') || window.sessionStorage.getItem('eg_qa_session') === 'true';
    } catch (error) {
      return false;
    }
  }

  function stopOfferVisibilityChecks(disconnect) {
    offerVisibilityStates.forEach(function (state) {
      if (state.interval) window.clearInterval(state.interval);
      state.interval = 0;
      state.startedAt = 0;
      state.clarityWaits = 0;
      if (disconnect && state.observer) state.observer.disconnect();
    });
  }

  function emitOfferSeen() {
    if (offerSeenEmitted || isQaSession() || typeof window.clarity !== 'function') return false;
    window.clarity('event', 'hat_offer_seen');
    offerSeenEmitted = true;
    stopOfferVisibilityChecks(true);
    return true;
  }

  function visibleSample(element, minimumRatio) {
    if (!element || element.closest('[hidden]')) return false;
    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;

    var rect = element.getBoundingClientRect();
    if (!rect.width || !rect.height) return false;
    var left = Math.max(0, rect.left);
    var right = Math.min(window.innerWidth, rect.right);
    var top = Math.max(0, rect.top);
    var bottom = Math.min(window.innerHeight, rect.bottom);
    var visibleWidth = Math.max(0, right - left);
    var visibleHeight = Math.max(0, bottom - top);
    if ((visibleWidth * visibleHeight) / (rect.width * rect.height) < minimumRatio) return false;

    var sampleX = left + visibleWidth / 2;
    var sampleY = top + visibleHeight / 2;
    var topElement = document.elementFromPoint(sampleX, sampleY);
    return Boolean(topElement && (topElement === element || element.contains(topElement)));
  }

  function potentiallyVisible(state) {
    return !offerSeenEmitted &&
      document.visibilityState === 'visible' &&
      !state.widget.hidden &&
      state.headingIntersecting &&
      state.visibleRows >= 2;
  }

  function stopStateInterval(state) {
    if (state.interval) window.clearInterval(state.interval);
    state.interval = 0;
    state.startedAt = 0;
    state.clarityWaits = 0;
  }

  function checkOfferVisibility(state) {
    if (offerSeenEmitted) return;
    try {
      var sampledRows = state.rows.filter(function (row) { return visibleSample(row, 0.5); }).length;
      var visible = potentiallyVisible(state) &&
        !state.widget.hidden &&
        visibleSample(state.heading, 0.5) &&
        sampledRows >= 2;

      if (!visible) {
        state.startedAt = 0;
        return;
      }
      if (typeof window.clarity !== 'function') {
        state.startedAt = 0;
        state.clarityWaits += 1;
        if (state.clarityWaits >= 50) stopStateInterval(state);
        return;
      }
      state.clarityWaits = 0;
      if (!state.startedAt) state.startedAt = window.performance.now();
      if (window.performance.now() - state.startedAt >= OFFER_SEEN_DWELL_MS) emitOfferSeen();
    } catch (error) {
      state.startedAt = 0;
    }
  }

  function updateStateInterval(state) {
    if (offerSeenEmitted) {
      stopStateInterval(state);
      return;
    }
    if (!potentiallyVisible(state)) {
      stopStateInterval(state);
      return;
    }
    if (!state.interval) state.interval = window.setInterval(function () { checkOfferVisibility(state); }, 100);
    checkOfferVisibility(state);
  }

  function observeOfferSeen(widget) {
    if (widget._egOfferSeenObserved || offerSeenEmitted || isQaSession()) return;
    var heading = widget.querySelector('.eg-hat-offer__header h2');
    var rows = Array.prototype.slice.call(widget.querySelectorAll('[data-eg-tier]'));
    if (!heading || rows.length < 2 || typeof window.IntersectionObserver !== 'function') return;

    var state = {
      widget: widget,
      heading: heading,
      rows: rows,
      headingIntersecting: false,
      visibleRows: 0,
      startedAt: 0,
      clarityWaits: 0,
      interval: 0,
      observer: null
    };
    try {
      state.observer = new IntersectionObserver(function (entries) {
        try {
          entries.forEach(function (entry) {
            if (entry.target === heading) state.headingIntersecting = entry.isIntersecting && entry.intersectionRatio >= 0.5;
            var rowIndex = rows.indexOf(entry.target);
            if (rowIndex !== -1) entry.target._egOfferRowIntersecting = entry.isIntersecting && entry.intersectionRatio >= 0.5;
          });
          state.visibleRows = rows.filter(function (row) { return row._egOfferRowIntersecting; }).length;
          updateStateInterval(state);
        } catch (error) {
          stopStateInterval(state);
        }
      }, { threshold: [0, 0.5] });
      widget._egOfferSeenObserved = true;
      widget._egOfferSeenState = state;
      offerVisibilityStates.push(state);
      state.observer.observe(heading);
      rows.forEach(function (row) { state.observer.observe(row); });
    } catch (error) {
      widget._egOfferSeenObserved = false;
      if (state.observer) state.observer.disconnect();
    }
  }

  document.addEventListener('visibilitychange', function () {
    offerVisibilityStates.forEach(updateStateInterval);
  });
  window.addEventListener('load', function () {
    offerVisibilityStates.forEach(updateStateInterval);
  });
  window.addEventListener('pagehide', function () {
    stopOfferVisibilityChecks(true);
  });
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted || offerSeenEmitted) return;
    offerVisibilityStates = [];
    widgets.forEach(function (widget) {
      widget._egOfferSeenObserved = false;
      observeOfferSeen(widget);
    });
  });

  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  }

  function variants(widget) {
    if (widget._egVariants) return widget._egVariants;
    try { widget._egVariants = JSON.parse(widget.dataset.variants || '[]'); } catch (error) { widget._egVariants = []; }
    return widget._egVariants;
  }

  function selectedVariant(widget) {
    return variants(widget).find(function (variant) {
      return String(variant.id) === String(widget.dataset.currentVariantId);
    }) || {
      id: widget.dataset.currentVariantId,
      price: Number(widget.dataset.currentVariantPrice) || 0,
      available: widget.dataset.currentVariantAvailable !== 'false'
    };
  }

  function cartPrices(cart, eligibleIds) {
    var prices = [];
    (cart.items || []).forEach(function (item) {
      if (!eligibleIds.has(String(item.product_id))) return;
      var unitPrice = Number(item.original_price != null ? item.original_price : item.price) || 0;
      for (var i = 0; i < Math.max(0, Number(item.quantity) || 0); i += 1) prices.push(unitPrice);
    });
    return prices;
  }

  function projectedPrices(existingPrices, selectedPrice, tier) {
    var result = existingPrices.slice(0, tier);
    while (result.length < tier) result.push(selectedPrice);
    return result;
  }

  function tierTotal(prices, tier) {
    var merchandise = prices.reduce(function (sum, price) { return sum + price; }, 0);
    var lowest = Math.min.apply(Math, prices);
    if (tier === 3) merchandise -= Math.round(lowest / 2);
    if (tier === 4) merchandise -= lowest;
    var shipping = merchandise >= FREE_SHIPPING_CENTS ? 0 : SHIPPING_CENTS;
    return { merchandise: merchandise, shipping: shipping, total: merchandise + shipping };
  }

  function render(widget, cart, eligibleIds) {
    var variant = selectedVariant(widget);
    if (!eligibleIds.has(String(widget.dataset.productId)) || !variant.available || !variant.price) {
      widget.hidden = true;
      try { if (widget._egOfferSeenState) stopStateInterval(widget._egOfferSeenState); } catch (error) { /* Analytics must not affect offer rendering. */ }
      return;
    }
    widget.hidden = false;
    var existingPrices = cartPrices(cart, eligibleIds);
    var count = existingPrices.length;
    var target = count < 3 ? 3 : count === 3 ? 4 : 0;
    widget.querySelectorAll('[data-eg-tier]').forEach(function (row) {
      var tier = Number(row.dataset.egTier);
      var prices = projectedPrices(existingPrices, Number(variant.price), tier);
      var result = tierTotal(prices, tier);
      row.classList.toggle('is-target', tier === target);
      row.querySelector('[data-eg-tier-total]').textContent = money(result.total);
      row.querySelector('[data-eg-tier-detail]').textContent = money(result.merchandise) + (result.shipping ? ' + ' + money(result.shipping) + ' shipping' : ' + FREE shipping');
    });
    var context = widget.querySelector('[data-eg-offer-context]');
    if (context) context.textContent = count ? 'Based on ' + count + ' eligible ' + (count === 1 ? 'hat' : 'hats') + ' in your cart and this selection' : 'Estimated total using this hat’s selected price';
    try {
      observeOfferSeen(widget);
      if (widget._egOfferSeenState) updateStateInterval(widget._egOfferSeenState);
    } catch (error) { /* Analytics must not affect offer rendering. */ }
  }

  function refresh(cart) {
    Promise.all([
      cart ? Promise.resolve(cart) : fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (response) { return response.json(); }),
      eligibleIdsPromise
    ]).then(function (values) {
      widgets.forEach(function (widget) { render(widget, values[0], values[1]); });
    }).catch(function () {
      widgets.forEach(function (widget) {
        widget.querySelectorAll('[data-eg-tier]').forEach(function (row) { row.classList.remove('is-target'); });
      });
    });
  }

  document.addEventListener('product:variant-change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || variant.id == null) return;
    widgets.forEach(function (widget) {
      if (!variants(widget).some(function (candidate) { return String(candidate.id) === String(variant.id); })) return;
      widget.dataset.currentVariantId = String(variant.id);
      widget.dataset.currentVariantPrice = String(variant.price || 0);
      widget.dataset.currentVariantAvailable = String(Boolean(variant.available));
    });
    refresh();
  });

  ['cart:updated', 'cart:item-added', 'eg:headwear-discount-checked', 'aftersell-upcart:public-events:cart-updated'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      var detailCart = event.detail && event.detail.cart;
      refresh(detailCart && Array.isArray(detailCart.items) ? detailCart : null);
    });
  });

  refresh();
})();
